export default __webpack_public_path__ + "static/mosaic-cursor-dont-dark-d00df40e15b04217af606b0f401e28cb04019f8b525ccbd04172287d681467c3.png";